export default __webpack_public_path__ + "static/logo-cff53e4f9e534586cac6bf70502e9090.png";